import { ADD_IMAGE_CONFIG_LIST_DETAILS, ADD_IMAGE_CONFIG_LIST_DETAILS_ERROR, ADD_IMAGE_CONFIG_LIST_DETAILS_SUCCESS, DATA_GENERATIONTYPE, DATA_GENERATIONTYPE_ERROR, DATA_GENERATIONTYPE_SUCCESS, DELETE_IMAGE_CONFIG_LIST_DETAILS, DELETE_IMAGE_CONFIG_LIST_DETAILS_ERROR, DELETE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS, IMAGE_CONFIG_LIST, IMAGE_CONFIG_LIST_DETAILS, IMAGE_CONFIG_LIST_DETAILS_ERROR, IMAGE_CONFIG_LIST_DETAILS_SUCCESS, IMAGE_CONFIG_LIST_ERROR, IMAGE_CONFIG_LIST_SUCCESS, MODEL_CLASSIFICATION, MODEL_CLASSIFICATION_ERROR, MODEL_CLASSIFICATION_SUCCESS, MODELTYPE_LIST, MODELTYPE_LIST_ERROR, MODELTYPE_LIST_SUCCESS, UPDATE_IMAGE_CONFIG_LIST_DETAILS, UPDATE_IMAGE_CONFIG_LIST_DETAILS_ERROR, UPDATE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS } from './constants';

export default function imageconfigReducer(state, action) {
	let imgconfig = [];
	let datagentype = [];
	let modeltype = [];
	let modelclassification = [];
	
	switch (action.type) {
	case IMAGE_CONFIG_LIST:
		return { ...state, pending: true };
      
	case IMAGE_CONFIG_LIST_SUCCESS:
        
		if (action.payload && action.payload.data.length > 0) {
			action.payload.data.map( (item) => {
            
				let data = {};

				data.id = item.id ? item.id : 0;
				data.pipelineId = item.pipelineId ? item.pipelineId : 0;
				data.name = item.name ? item.name : '';
				data.channelinfoId = item.channelinfoId ? item.channelinfoId : 0;
				data.batchSize = item.batchSize ? item.batchSize : 0;
				data.targetHeight = item.targetHeight ? item.targetHeight : 0;
				data.targetWidth = item.targetWidth ? item.targetWidth : 0;
				data.modelPath = item.modelPath ? item.modelPath : 'N/A';
				data.eventTypes = item.eventTypes ? item.eventTypes : '';
				data.timeTolerance = item.timeTolerance ? item.timeTolerance : '';
				data.eventPositionTolerance = item.eventPositionTolerance ? item.eventPositionTolerance : '';
				data.isEnabled = item.isEnabled ? item.isEnabled : '';
				data.eventConfidenceThreshold = item.eventConfidenceThreshold ? item.eventConfidenceThreshold : '';
				data.eventWidthThreshold = item.eventWidthThreshold ? item.eventWidthThreshold : '';
				data.durationThreshold = item.durationThreshold ? item.durationThreshold : '';
				data.pidsinfoId = item.pidsinfoId ? item.pidsinfoId : 0;
				data.createdAt = item.createdAt ? item.createdAt : '';
				data.updatedAt = item.updatedAt ? item.updatedAt : '';
				data.pidsname = item.pidsinfo.name ? item.pidsinfo.name : '';
				data.channelname = item.channelinfo.name ? item.channelinfo.name : '';
				data.curlPath = item.curlPath ? item.curlPath : 'N/A';
				data.pickleFilePath = item.pickleFilePath ? item.pickleFilePath : 'N/A';
				data.wellalgorithmId = item.wellalgorithmId ? item.wellalgorithmId : 0;
				data.datagenerationName = item.datagenerationtype && item?.datagenerationtype?.name ? item.datagenerationtype.name : ''; 
				data.confidenceThreshold = item && item?.confidenceThreshold ? item.confidenceThreshold : 0;
				data.curlEnabled = item && item?.curlEnabled ? item.curlEnabled : false;
				data.modeltypeName = item.modeltype && item?.modeltype?.name ? item?.modeltype?.name : '' ;
				data.alias = item &&  item?.modelclassifications?.alias ? item?.modelclassifications?.alias : item?.modelclassifications?.modelLevel ? item?.modelclassifications?.modelLevel : '-';
				data.modelclassificationId = item && item?.modelclassificationId ? item.modelclassificationId : null;
				data.datagenerationtypeId = item && item?.datagenerationtypeId ? item.datagenerationtypeId : null;
				data.modeltypeId = item && item?.modeltypeId ? item.modeltypeId : null;
				data.modelClass = item && item?.modelconfiguration && item?.modelconfiguration?.eventTypes ? item?.modelconfiguration?.eventTypes : [];



				return imgconfig.push(data);
			});
          
			return { ...state, imgconfig: imgconfig, pending: false, error: false };
		} else {
			if (action.payload && action.payload.data.length === 0) {
				return { ...state, imgconfig: [], pending: false, error: false };
			} else {
				return { ...state, pending: false, error: true };
			}
		}

	case DATA_GENERATIONTYPE:
		return { ...state, loading: true, error: false };
							
	case DATA_GENERATIONTYPE_SUCCESS:
		if(action?.payload?.data){
			action.payload.data && action.payload.data.map((item) => {
						
				datagentype.push({
					id : item && item.id ?item.id : null,
					name : item && item.name ? item.name : '',
				});
						
			});
		}	
				
		
		return { ...state, loading: false, datagentype : datagentype , error: false };
							
	case DATA_GENERATIONTYPE_ERROR:
		return { ...state, loading: false, error: true };

	case MODELTYPE_LIST:
		return { ...state, loading : true, error : false};
		
	case MODELTYPE_LIST_SUCCESS:
		if(action?.payload.data){
			action?.payload?.data?.map((item) => {
				modeltype.push({
					id : item && item?.id ? item.id : null,
					name : item && item?.name ? item.name : '',
				});
			});
		}
		
		return {...state, modeltype : modeltype,  loading : false, error : false};
		
	case MODELTYPE_LIST_ERROR:
		return { ...state, modeltype : [], loading : false, error : true};
	case MODEL_CLASSIFICATION:
		return { ...state, loading : true, error : false};
		
	case MODEL_CLASSIFICATION_SUCCESS:
		if(action?.payload.data){
			action?.payload?.data?.map((item) => {
				modelclassification.push({
					id : item && item?.id ? item.id : null,
					alias : item && item?.alias ? item.alias : item?.modelLevel ? item.modelLevel : '',
				});
			});
		}
		
		return {...state, modelclassification : modelclassification,  loading : false, error : false};
		
	case MODEL_CLASSIFICATION_ERROR:
		return { ...state, modeltype : [], loading : false, error : true};
      
	case IMAGE_CONFIG_LIST_ERROR:
		return { ...state, pending: false, error: true };

	case IMAGE_CONFIG_LIST_DETAILS:
		return { ...state, pending: true };

	case IMAGE_CONFIG_LIST_DETAILS_SUCCESS:
		return { ...state, details: action.payload, pending: false, error: false };

	case IMAGE_CONFIG_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case ADD_IMAGE_CONFIG_LIST_DETAILS:
		return { ...state, pending: false };

	case ADD_IMAGE_CONFIG_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case ADD_IMAGE_CONFIG_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	case UPDATE_IMAGE_CONFIG_LIST_DETAILS:
		return { ...state, pending: false };

	case UPDATE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case UPDATE_IMAGE_CONFIG_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };
      
	case DELETE_IMAGE_CONFIG_LIST_DETAILS:
		return { ...state, pending: false };

	case DELETE_IMAGE_CONFIG_LIST_DETAILS_SUCCESS:
		return { ...state, pending: false, error: false };

	case DELETE_IMAGE_CONFIG_LIST_DETAILS_ERROR:
		return { ...state, pending: false, error: true };

	default: {
		throw Error('Unknown action: ' + action.type);
	}
	}
}